import { AiDataIntelligencePageProvider } from "../../context/industryPageProviders";
import IndustryPageLayout from "./IndustryPageLayout";

export default function AiDataIntelligence() {
  return (
    <AiDataIntelligencePageProvider>
      <IndustryPageLayout />
    </AiDataIntelligencePageProvider>
  );
}
